import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import Stream from 'flarum/common/utils/Stream';
export default function addRegistrationSecurityQuestion() {
  extend(SignUpModal.prototype, 'oninit', function () {
    this.securityAnswer = Stream('');
    this.securityToken = Stream('');
    this.securityQuestionText = Stream('');
    this.securityQuestionLoading = Stream(true);
    this.securityQuestionEnabled = Stream(false);

    // Cargar la pregunta aleatoria desde la API
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/security-questions/registration'
    }).then(res => {
      if (res && res.enabled && res.token) {
        this.securityQuestionEnabled(true);
        this.securityToken(res.token);

        // Detectar si el locale activo del usuario es euskera o castellano/otro
        const locale = (app.translator.getLocale ? app.translator.getLocale() : app.translator.locale) || app.translator.formatter && app.translator.formatter.locale || 'es';
        const isBasque = locale === 'eu' || locale === 'eu_ES';
        const text = isBasque && res.question_eu ? res.question_eu : res.question_es;
        this.securityQuestionText(text);
      } else {
        this.securityQuestionEnabled(false);
      }
      this.securityQuestionLoading(false);
      m.redraw();
    }).catch(() => {
      this.securityQuestionLoading(false);
      this.securityQuestionEnabled(false);
      m.redraw();
    });
  });
  extend(SignUpModal.prototype, 'fields', function (items) {
    if (this.securityQuestionLoading()) {
      return;
    }
    if (!this.securityQuestionEnabled() || !this.securityToken()) {
      return;
    }
    const questionTitle = this.securityQuestionText();
    items.add('security-question', m('.Form-group.SecurityQuestion-group', [m('label.Form-group-label', [m('i.fas.fa-shield-alt', {
      style: 'margin-right: 6px; color: var(--primary-color);'
    }), questionTitle, ' ', m('span', {
      style: 'color: red;'
    }, '*')]), m('input.FormControl', {
      name: 'security_answer',
      type: 'text',
      placeholder: app.translator.trans('nagusi-match-ratings.forum.security_questions.placeholder'),
      value: this.securityAnswer(),
      oninput: e => {
        this.securityAnswer(e.target.value);
      },
      disabled: this.loading,
      required: true,
      autocomplete: 'off'
    }), m('.helpText', app.translator.trans('nagusi-match-ratings.forum.security_questions.help'))]), -5 // Último campo del formulario, justo antes del botón de Registrarse (-10)
    );
  });
  extend(SignUpModal.prototype, 'submitData', function (data) {
    if (this.securityQuestionEnabled() && this.securityToken()) {
      data.security_token = this.securityToken();
      data.security_answer = this.securityAnswer();
    }
  });
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/addRegistrationSecurityQuestion', addRegistrationSecurityQuestion);